var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEzy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-ezy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.337,
    height: 19.525,
    viewBox: "0 0 107.337 19.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M11.688,14.376H2.7a3.022,3.022,0,0,0,1.035,1.9,3.3,3.3,0,0,0,2.161.7,3.728,3.728,0,0,0,2.694-1.1l2.356,1.106a5.605,5.605,0,0,1-2.11,1.854,6.648,6.648,0,0,1-2.92.594,5.78,5.78,0,0,1-4.272-1.649A5.647,5.647,0,0,1,0,13.628,5.812,5.812,0,0,1,1.639,9.4a5.53,5.53,0,0,1,4.128-1.69A5.717,5.717,0,0,1,10.049,9.4,6.072,6.072,0,0,1,11.7,13.843Zm-2.807-2.2a2.8,2.8,0,0,0-1.1-1.516A3.137,3.137,0,0,0,5.9,10.073a3.338,3.338,0,0,0-2.049.656,3.653,3.653,0,0,0-1.024,1.444Z",
    transform: "translate(0 -3.691)",
    fill: "#f7fafc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M25.167,8.257h8.554L28.7,17.036h4.733V19.4H24.4l5.04-8.779H25.167Z",
    transform: "translate(-11.685 -3.955)",
    fill: "#f7fafc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M42.938,8.257H45.8l2.9,7,3.2-7H54.76L47.773,23.48H44.884l2.295-4.907Z",
    transform: "translate(-20.565 -3.955)",
    fill: "#f7fafc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M82.426,3.032,80.418,4.948a6.222,6.222,0,0,0-4.61-2.161A5.039,5.039,0,0,0,70.686,7.9a5.368,5.368,0,0,0,.656,2.674A4.7,4.7,0,0,0,73.2,12.406a5.391,5.391,0,0,0,2.663.666,5.551,5.551,0,0,0,2.284-.461,8.288,8.288,0,0,0,2.274-1.7l1.946,2.028A10.768,10.768,0,0,1,79.209,15.2a8.677,8.677,0,0,1-3.391.625A7.833,7.833,0,0,1,70.061,13.6a7.74,7.74,0,0,1-2.233-5.716,7.847,7.847,0,0,1,1.014-4.005,7.627,7.627,0,0,1,2.92-2.817A8.262,8.262,0,0,1,75.859,0a8.511,8.511,0,0,1,3.585.789A8.574,8.574,0,0,1,82.426,3.032Z",
    transform: "translate(-32.486)",
    fill: "#ed8936"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M104.826,7.707a5.878,5.878,0,0,1,2.96.789,5.686,5.686,0,0,1,2.172,2.141,5.749,5.749,0,0,1,.779,2.92,5.825,5.825,0,0,1-.789,2.95,5.652,5.652,0,0,1-2.131,2.151,5.929,5.929,0,0,1-2.981.768,5.585,5.585,0,0,1-4.1-1.7,5.685,5.685,0,0,1-1.69-4.149,5.639,5.639,0,0,1,1.916-4.354A5.6,5.6,0,0,1,104.826,7.707Zm.041,2.633a2.88,2.88,0,0,0-2.172.912,3.216,3.216,0,0,0-.86,2.315,3.294,3.294,0,0,0,.85,2.356,3.066,3.066,0,0,0,4.353-.01,3.257,3.257,0,0,0,.871-2.346,3.207,3.207,0,0,0-.86-2.325A2.867,2.867,0,0,0,104.867,10.34Z",
    transform: "translate(-47.439 -3.691)",
    fill: "#ed8936"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M125.314,0h2.8V15.448h-2.8Z",
    transform: "translate(-60.018)",
    fill: "#ed8936"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M134.987,0h2.8V15.448h-2.8Z",
    transform: "translate(-64.651)",
    fill: "#ed8936"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M155.916,14.376h-8.984a3.022,3.022,0,0,0,1.035,1.9,3.3,3.3,0,0,0,2.161.7,3.727,3.727,0,0,0,2.694-1.1l2.356,1.106a5.6,5.6,0,0,1-2.11,1.854,6.647,6.647,0,0,1-2.919.594,5.78,5.78,0,0,1-4.272-1.649,5.648,5.648,0,0,1-1.649-4.149A5.812,5.812,0,0,1,145.867,9.4,5.53,5.53,0,0,1,150,7.707a5.717,5.717,0,0,1,4.282,1.69,6.073,6.073,0,0,1,1.65,4.446Zm-2.807-2.2a2.8,2.8,0,0,0-1.1-1.516,3.136,3.136,0,0,0-1.885-.584,3.338,3.338,0,0,0-2.049.656,3.653,3.653,0,0,0-1.024,1.444Z",
    transform: "translate(-69.077 -3.691)",
    fill: "#ed8936"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M181.435,10.247l-2.325,1.28a3.923,3.923,0,0,0-1.3-.953,3.852,3.852,0,0,0-1.5-.266,3.5,3.5,0,0,0-2.54.942,3.19,3.19,0,0,0-.963,2.4,3.091,3.091,0,0,0,.932,2.325,3.373,3.373,0,0,0,2.448.9,3.558,3.558,0,0,0,2.919-1.28l2.2,1.506a6.019,6.019,0,0,1-5.06,2.325,6.086,6.086,0,0,1-4.61-1.741,5.8,5.8,0,0,1,1.4-9.2,6.77,6.77,0,0,1,3.247-.779,6.531,6.531,0,0,1,2.981.666A5.616,5.616,0,0,1,181.435,10.247Z",
    transform: "translate(-81.412 -3.691)",
    fill: "#ed8936"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M196.149.374h2.787V4.481h1.66V6.889h-1.66v8.738h-2.787V6.889h-1.434V4.481h1.434Z",
    transform: "translate(-93.258 -0.179)",
    fill: "#ed8936"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M106.353,17.412l2.961-1.705,0,3.417Z",
    transform: "translate(-50.937 -7.523)",
    fill: "#f7fafc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEzy);
export default __webpack_public_path__ + "static/media/logo-ezy.eb637dc80e8d4f76a743beafc8569015.svg";
export { ForwardRef as ReactComponent };